import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WifiMediumFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M16.38 14.78C15.2 13.86 13.82 13.16 12 13.16C10.18 13.16 8.8 13.86 7.62 14.78L5.64 12.42C7.24 11.14 9.58 9.98 12 9.98C14.42 9.98 16.76 11.14 18.36 12.42L16.38 14.78ZM12 19.6L9 16.36C9.78 15.62 10.94 15.1 12 15.1C13.06 15.1 14.22 15.62 15 16.36L12 19.6Z" />
    </SvgIcon>
  );
});
